/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface OrgTypeSpec { 
    /**
     * VCDS org type
     */
    vcds_org_type: string;
    /**
     * Description for this VCDS org type
     */
    description: string;
}

